import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'
import React from 'react'

const uploadResultItemLoadingStyles = makeStyles((theme: Theme) => ({
    uploadResultItemLoadingContainer: {
        marginBottom: theme.spacing(1),
    },
}))

const UploadResultItemLoading = () => {
    const classes = uploadResultItemLoadingStyles()
    return (
        <GridContainer
            spacing={3}
            className={clsx(
                classes.uploadResultItemLoadingContainer,
                'uploadResultItemLoadingContainer'
            )}
            alignItems="center"
        >
            <GridItem>
                <Skeleton variant="rect" width={190} height={95} />
            </GridItem>
            <GridItem sm={5}>
                <Skeleton variant="text" />
            </GridItem>
            <GridItem sm={3}>
                <Skeleton variant="text" />
            </GridItem>
        </GridContainer>
    )
}

export default UploadResultItemLoading
